import { render, staticRenderFns } from "./TableImportContacts.vue?vue&type=template&id=080d394c&scoped=true&"
import script from "./TableImportContacts.vue?vue&type=script&lang=js&"
export * from "./TableImportContacts.vue?vue&type=script&lang=js&"
import style0 from "./TableImportContacts.vue?vue&type=style&index=0&id=080d394c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080d394c",
  null
  
)

export default component.exports